import helper from './helper'

const urlPrefix = 'voucher'

export default {
  async getAll(id) {
    return await helper.get(`${urlPrefix}/${id}`)
  },
  async add(item) {
    return await helper.post(`${urlPrefix}/add`, item)
  },
  async remove(item) {
    return await helper.delete(`${urlPrefix}/${item._id}`)
  },
  async export(id) {
    await helper.get(`${urlPrefix}/export/${id}`)
    window.location = '/api/admin/download-export/vouchers-' + id
  }
}
